export default [
  {
    path: '/caps',
    component: () => import('@/pages/Caps/Index.vue'),
  },
  {
    path: '/caps/ma-no-caps',
    component: () => import('@/pages/Caps/MaNoCaps/Index.vue'),
  },
]
